// Libraries
import React from 'react';
import { useSelector } from 'react-redux';
// Components
import ConsentStatusContent from './ConsentStatusContent';

/**
 * Gate for the Patient Summary consent status line (SPMDEV-461).
 *
 * Renders nothing unless the tenant has the bridge eligibility checker setting enabled AND the
 * patient is a Bridge patient (has a `bridge_patient_id` identification) — the same signals used by
 * the EligibilityCheck component. When ineligible this returns null before ConsentStatusContent
 * mounts, so the consent-status fetch never fires for non-Bridge patients.
 */
export function ConsentStatus() {
  const isBridgeEligibilityCheckerDisplayed = useSelector(
    (state) => (state.tenant ? state.tenant.isBridgeEligibilityCheckerDisplayed : false),
  );
  const nonUniquePatientIdentifications = useSelector(
    (state) => (state.patient ? state.patient.nonUniquePatientIdentifications : undefined) || [],
  );
  const isBridgePatient = nonUniquePatientIdentifications
    .some((identification) => identification.root === 'bridge_patient_id');

  if (!isBridgeEligibilityCheckerDisplayed || !isBridgePatient) {
    return null;
  }

  return <ConsentStatusContent />;
}

export default ConsentStatus;
